export default "__VITE_ASSET__DLFJwGhJ__"